require('./core-page.scss');
require('src/creative/nav/nav');
require('src/interlock/product/global-footer/global-footer');
require('src/creative/core-page/submodel-selector/submodel-selector');
require('src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel');
require('src/interlock/ui/subnav/subnav');
require('src/interlock/no-ui/defer/feed-loader');
require('src/interlock/ui/base-carousel/base-carousel');
require('src/interlock/ui/owl-carousel/owl-carousel');
require('src/interlock/no-ui/engagement-handler/url-push-state-engagement-handler/url-push-state-engagement-handler');
require('src/interlock/core-page/dynamic-header/dynamic-header');
require('src/interlock/core-page/module-anchor/module-anchor');

require('src/interlock/product/sentiment-widget/sentiment-widget');

require('src/interlock/product/internal-links/internal-links');
require('src/interlock/core-page/billboard-unit/billboard-unit');
require('src/creative/ads/adhesion-units/adhesion-units');

require('src/creative/core-page/pricing/pricing');
require('src/creative/core-page/used/pricing/pricing');
require('src/creative/core-page/used/car-valuation/car-valuation');
require('src/creative/core-page/dealer-inventory/dealer-inventory');
require('src/creative/core-page/build/build');
require('src/creative/ads/ads');
require('src/creative/core-page/editorial-review/editorial-review');


var trackingMap = require('src/interlock/no-ui/tracking/maps/core-page'),
    trackingHandler = require('src/interlock/no-ui/tracking/handler');

trackingHandler.useMap(trackingMap);



//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/core-page-web-437.js
// module id = 460
// module chunks = 1